import { Button, Text } from '@mantine/core';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { IconPlus } from '@tabler/icons';
import { useStyles } from './styles';
import { useEffect } from 'react';
import { RolesCreateForm } from './form';
import { Modal } from '@/components/modal';
import { useTranslation } from 'react-i18next';

export const CreateRoles = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const { classes } = useStyles();
  const { t } = useTranslation();

  const isMobile = useMediaQuery('(max-width: 1200px)');

  useEffect(() => {
    return () => {
      close();
    };
  }, []);

  return (
    <>
      <Button
        data-cy="createRole"
        size="md"
        leftSection={<IconPlus />}
        className={classes.createButton}
        onClick={open}
      >
        <Text fw="600">{isMobile ? '' : t('create')}</Text>
      </Button>

      <Modal opened={opened} onClose={close} title={t('roles.create')} zIndex={1002}>
        <RolesCreateForm close={close} />
      </Modal>
    </>
  );
};
